export default "__VITE_ASSET__CalRo91D__"